import React from 'react';
import {observer} from 'mobx-react';
import {Panel} from 'shared/components';
import {Table} from 'main/components';
import {HtmlRender} from 'shared/components';
import {FormattedMessage} from 'react-intl';

const COLUMNS = [
  {
    header: 'payroll.diffs.Field',
    attribute: 'name',
    width: 4
  },
  {
    header: 'payroll.diffs.Old Value',
    render: (model) => <HtmlRender html={model.oldValue}/>,
    width: 3
  },
  {
    header: 'payroll.diffs.New Value',
    render: (model) => <HtmlRender html={model.newValue}/>,
    width: 3
  },
  {
  header: 'payroll.diffs.Status',
  render: (model) => <div className={`${model.status === 'needs_revision' ? 'scarlet' : ''}`}>
    <FormattedMessage id={`payroll.diffs.${model.status}`}/>
  </div>,
  width: 2
  }
];

const PayrollSections = observer(({diff}) => {
  return (
    diff.payrollSections.map(section =>
      <Panel key={section.id}>
        <Panel.Header title={section.name}/>
        <Table
          columns={COLUMNS}
          models={section.payrollFields}
          showLinks={false}
        />
      </Panel>
    )
  );
});

export default PayrollSections;
